import { Typography } from '@material-ui/core'
import { AutoCompleteInputMultiSelect } from 'bpm/pages/ProductsPage/AddProductDialog/AutoCompleteInput'
import React, { ChangeEvent, useCallback } from 'react'
import { FilterProps } from 'react-table'

type CustomFilterSelectProps = {
    disabled?: boolean
    options: any[]
    groupBy: (option: any) => string
    getOptionLabel: (option: any) => string
    getOptionSelected?: (option: any, value: any) => boolean
    wrapperClassName?: string
    wrapperStyle?: React.CSSProperties
    [key: string]: any
}

const CustomFilterSelect = ({
    options,
    disabled,
    groupBy,
    getOptionLabel,
    getOptionSelected,
    wrapperClassName,
    wrapperStyle,
    ...props
}: CustomFilterSelectProps) => {
    return ({
        column: { id, filterValue = [], setFilter },
    }: FilterProps<any>) => {
        const onSelectChange = (event: ChangeEvent<{}>, value: any[]) => {
            return setFilter(value)
        }

        const noop = useCallback(() => {}, [])

        return (
            <Typography
                component="div"
                className={wrapperClassName}
                data-testid={`${id}_Filter`}
                style={wrapperStyle}
            >
                <AutoCompleteInputMultiSelect
                    name={id}
                    items={options}
                    selectedValues={filterValue}
                    handleChange={onSelectChange}
                    disabled={disabled}
                    getOptionLabel={getOptionLabel}
                    groupBy={groupBy}
                    handleInputChange={noop}
                    valid={true}
                    variant="standard"
                    limitTags={0}
                    size="small"
                    getOptionSelected={getOptionSelected}
                    {...props}
                />
            </Typography>
        )
    }
}

export default CustomFilterSelect
